// Shared presentation styles/handlers for ManualTripCreator.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (the module-level
// `inputStyle` object and the `handleFocus`/`handleBlur` focus handlers used by
// the form fields) as part of the behavior-preserving refactor (issue #240).
// Values, keys, and ordering are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

// ── Shared styles ─────────────────────────────────────────────────────────────

export const inputStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '14px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  outline: 'none',
  transition: 'border-color 0.2s',
  boxSizing: 'border-box'
};

export const handleFocus = (e) => { e.target.style.borderColor = '#0ea5e9'; };
export const handleBlur = (e) => { e.target.style.borderColor = '#d1d5db'; };
